import { useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { IoGridOutline } from 'react-icons/io5';
import LoadSpinner from '../Shared/ComponentLoading';
import { defaultGridColumnDef } from '../Shared/Grid';
import { FormatCurrencyCell } from '../Functions/NumberFormatter';

const DashboardTransactions = ({ data, loading }) => {
    const columnDefs = useMemo(() => [
        {
            headerName: 'Date', field: 'transactionDate', suppressMovable: true, maxWidth: 125,
            valueGetter: ({ data: row }) => {
                const value = row.transactionDate;
                return typeof value === 'string' && value.includes('T') ? value.split('T')[0] : value;
            },
        },
        { headerName: 'Category', field: 'categoryId', suppressMovable: true, maxWidth: 125 },
        { headerName: 'Description', field: 'transactionDescription', suppressMovable: true, maxWidth: 500 },
        { headerName: 'Account', field: 'accountId', suppressMovable: true, maxWidth: 125 },
        {
            headerName: 'Amount', field: 'value', suppressMovable: true,
            filter: 'agNumberColumnFilter', type: 'numericColumn', maxWidth: 300,
            valueFormatter: FormatCurrencyCell,
        },
    ], []);

    return (
        <Row>
            <Col xs="12">
                <Card className="mt-2">
                    <CardHeader className="cd-header">
                        <div className="d-flex">
                            <IoGridOutline size={24} style={{ color: '#111' }} />&nbsp;&nbsp;<div>Recent Transactions</div>
                        </div>
                    </CardHeader>
                    <CardBody style={{ height: '400px' }}>
                        {loading ? <LoadSpinner /> : (
                            <div className="ag-theme-balham" style={{ height: '100%', width: '100%' }}>
                                <AgGridReact
                                    rowData={data}
                                    columnDefs={columnDefs}
                                    pagination={true}
                                    defaultColDef={defaultGridColumnDef}
                                    paginationPageSizeSelector={[10, 20, 50]}
                                    paginationPageSize={10}
                                    overlayNoRowsTemplate="No Records Found"
                                />
                            </div>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default DashboardTransactions;
